var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-content',{scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._v(" "+_vm._s(_vm.$t('db.breadcrumb.database.import'))+" ")]},proxy:true}])},[_c('recipient-table',_vm._b({},'recipient-table',_vm.recipents_props,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }